import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width="58.923538mm"
    height="8.9504204mm"
    viewBox="0 0 58.923538 8.9504204"
    id="svg7688"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs7685" />
    <g id="layer1" transform="translate(336.52957,371.9498)">
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -324.819,-368.44677 c -0.23289,0.30041 -0.53743,0.41479 -0.82958,0.41479 -0.93431,0 -1.48552,-0.69867 -1.48552,-1.56959 0,-0.8971 0.55121,-1.59576 1.48552,-1.59576 0.61736,0 1.20165,0.38033 1.27331,1.0666 h -0.6339 c -0.0772,-0.33487 -0.32659,-0.5085 -0.63941,-0.5085 -0.59669,0 -0.82131,0.5085 -0.82131,1.03766 0,0.50299 0.22462,1.0101 0.82131,1.0101 0.43133,0 0.68075,-0.23151 0.71934,-0.65043 h -0.66835 v -0.49609 h 1.26917 v 1.63435 h -0.42306 l -0.0675,-0.34313"
        id="path3212"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -322.38125,-369.43344 c -0.0537,-0.30455 -0.18466,-0.4644 -0.4768,-0.4644 -0.38172,0 -0.49058,0.29627 -0.50023,0.4644 z m -0.97703,0.38171 c 0.0179,0.38034 0.20395,0.55397 0.53744,0.55397 0.24115,0 0.43683,-0.14883 0.47404,-0.28387 h 0.52917 c -0.1695,0.51676 -0.52917,0.73725 -1.02389,0.73725 -0.69039,0 -1.11758,-0.47543 -1.11758,-1.15204 0,-0.65595 0.45337,-1.1548 1.11758,-1.1548 0.74415,0 1.10381,0.62563 1.06247,1.29949 h -1.57923"
        id="path3214"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -321.42351,-370.29196 h 0.57188 v 0.30454 h 0.0124 c 0.15296,-0.24529 0.41479,-0.3638 0.66835,-0.3638 0.63941,0 0.79926,0.35967 0.79926,0.90124 v 1.34634 h -0.60082 v -1.2361 c 0,-0.35967 -0.10474,-0.53744 -0.38448,-0.53744 -0.32521,0 -0.46577,0.18191 -0.46577,0.62701 v 1.14653 h -0.60083 v -2.18832"
        id="path3216"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -317.43961,-369.43344 c -0.0551,-0.30455 -0.18741,-0.4644 -0.47817,-0.4644 -0.38172,0 -0.49197,0.29627 -0.50023,0.4644 z m -0.9784,0.38171 c 0.0165,0.38034 0.20395,0.55397 0.53743,0.55397 0.24116,0 0.43546,-0.14883 0.47405,-0.28387 h 0.52916 c -0.16949,0.51676 -0.52916,0.73725 -1.02388,0.73725 -0.69039,0 -1.11759,-0.47543 -1.11759,-1.15204 0,-0.65595 0.45338,-1.1548 1.11759,-1.1548 0.74414,0 1.10381,0.62563 1.06109,1.29949 h -1.57785"
        id="path3218"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -316.48325,-370.29196 h 0.57189 v 0.40652 h 0.008 c 0.11024,-0.27561 0.40652,-0.46578 0.69866,-0.46578 0.0413,0 0.0923,0.008 0.13092,0.0207 v 0.55948 c -0.0551,-0.0138 -0.1447,-0.022 -0.21636,-0.022 -0.43959,0 -0.59255,0.31833 -0.59255,0.7028 v 0.98668 h -0.60083 v -2.18832"
        id="path3220"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -313.47361,-369.17437 c -0.10198,0.0882 -0.31282,0.0923 -0.50023,0.12678 -0.18465,0.0372 -0.35415,0.10059 -0.35415,0.32108 0,0.22462 0.17363,0.27974 0.36793,0.27974 0.46991,0 0.48645,-0.37207 0.48645,-0.50436 z m -1.38769,-0.44511 c 0.0331,-0.56224 0.53744,-0.73174 1.02802,-0.73174 0.43546,0 0.96049,0.0978 0.96049,0.6215 v 1.13825 c 0,0.19982 0.0207,0.39826 0.0758,0.48783 h -0.6091 c -0.0207,-0.0689 -0.0386,-0.14056 -0.0427,-0.21222 -0.19017,0.19844 -0.46991,0.27148 -0.73587,0.27148 -0.41479,0 -0.74414,-0.20809 -0.74414,-0.65595 0,-0.49609 0.37207,-0.61461 0.74414,-0.66559 0.36794,-0.0537 0.71107,-0.0413 0.71107,-0.28663 0,-0.25907 -0.17777,-0.29628 -0.38861,-0.29628 -0.22875,0 -0.37758,0.0923 -0.39825,0.32935 h -0.60083"
        id="path3222"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -312.3891,-371.12568 h 0.60083 v 3.02204 h -0.60083 v -3.02204"
        id="path3224"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -311.29631,-370.29196 h 0.59945 v 2.18832 h -0.59945 z m 0.59945,-0.339 h -0.59945 v -0.49472 h 0.59945 v 0.49472"
        id="path3226"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -309.46076,-370.29196 h 0.44097 v 0.40238 h -0.44097 v 1.08314 c 0,0.20257 0.051,0.25356 0.25493,0.25356 0.0634,0 0.12265,-0.004 0.18604,-0.0165 v 0.46991 c -0.10198,0.0165 -0.23289,0.0207 -0.3514,0.0207 -0.36932,0 -0.6904,-0.0854 -0.6904,-0.5209 v -1.28984 h -0.3638 v -0.40239 h 0.3638 v -0.65594 h 0.60083 v 0.65594"
        id="path3228"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -307.3689,-369.17437 c -0.10198,0.0882 -0.3142,0.0923 -0.50023,0.12678 -0.18603,0.0372 -0.35553,0.10059 -0.35553,0.32108 0,0.22462 0.17363,0.27974 0.36931,0.27974 0.46853,0 0.48645,-0.37207 0.48645,-0.50436 z m -1.38906,-0.44511 c 0.0345,-0.56224 0.53743,-0.73174 1.02939,-0.73174 0.43546,0 0.96049,0.0978 0.96049,0.6215 v 1.13825 c 0,0.19982 0.0207,0.39826 0.0758,0.48783 h -0.6091 c -0.022,-0.0689 -0.0386,-0.14056 -0.0427,-0.21222 -0.19017,0.19844 -0.46991,0.27148 -0.73587,0.27148 -0.41479,0 -0.74552,-0.20809 -0.74552,-0.65595 0,-0.49609 0.37345,-0.61461 0.74552,-0.66559 0.36794,-0.0537 0.71107,-0.0413 0.71107,-0.28663 0,-0.25907 -0.17777,-0.29628 -0.38999,-0.29628 -0.22875,0 -0.3762,0.0923 -0.39825,0.32935 h -0.60082"
        id="path3230"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -305.54025,-370.29196 h 0.4396 v 0.40238 h -0.4396 v 1.08314 c 0,0.20257 0.051,0.25356 0.25356,0.25356 0.0634,0 0.12265,-0.004 0.18604,-0.0165 v 0.46991 c -0.10198,0.0165 -0.23289,0.0207 -0.3514,0.0207 -0.36794,0 -0.68902,-0.0854 -0.68902,-0.5209 v -1.28984 h -0.3638 v -0.40239 h 0.3638 v -0.65594 h 0.60082 v 0.65594"
        id="path3232"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -302.59813,-369.89784 c -0.39412,0 -0.52917,0.33761 -0.52917,0.69728 0,0.34313 0.1571,0.7028 0.52917,0.7028 0.39687,0 0.51538,-0.34727 0.51538,-0.70693 0,-0.35554 -0.12678,-0.69315 -0.51538,-0.69315 z m 0.52365,1.51446 h -0.008 c -0.13918,0.23702 -0.38447,0.339 -0.66421,0.339 -0.66008,0 -0.98116,-0.56776 -0.98116,-1.17271 0,-0.58843 0.32522,-1.13413 0.96876,-1.13413 0.25769,0 0.51125,0.11024 0.64768,0.32659 h 0.008 v -1.10105 h 0.60083 v 3.02204 h -0.57189 v -0.27974"
        id="path3234"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -299.5761,-369.43344 c -0.0551,-0.30455 -0.18603,-0.4644 -0.47818,-0.4644 -0.38171,0 -0.49058,0.29627 -0.49885,0.4644 z m -0.97703,0.38171 c 0.0165,0.38034 0.20258,0.55397 0.53744,0.55397 0.24115,0 0.43546,-0.14883 0.47267,-0.28387 h 0.52916 c -0.1695,0.51676 -0.52916,0.73725 -1.02388,0.73725 -0.68902,0 -1.11621,-0.47543 -1.11621,-1.15204 0,-0.65595 0.452,-1.1548 1.11621,-1.1548 0.74552,0 1.10519,0.62563 1.06247,1.29949 h -1.57786"
        id="path3236"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -295.36481,-370.11006 c -0.0413,-0.30042 -0.32935,-0.52917 -0.66008,-0.52917 -0.59669,0 -0.81994,0.5085 -0.81994,1.03766 0,0.50299 0.22325,1.0101 0.81994,1.0101 0.40652,0 0.63527,-0.27836 0.68626,-0.67661 h 0.64217 c -0.0675,0.75378 -0.58705,1.2361 -1.32843,1.2361 -0.93431,0 -1.48553,-0.69867 -1.48553,-1.56959 0,-0.8971 0.55122,-1.59576 1.48553,-1.59576 0.66421,0 1.2237,0.38998 1.30362,1.08727 h -0.64354"
        id="path3238"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -292.94222,-369.17437 c -0.10197,0.0882 -0.31282,0.0923 -0.50023,0.12678 -0.18603,0.0372 -0.35553,0.10059 -0.35553,0.32108 0,0.22462 0.17363,0.27974 0.36931,0.27974 0.46853,0 0.48645,-0.37207 0.48645,-0.50436 z m -1.38768,-0.44511 c 0.0331,-0.56224 0.53605,-0.73174 1.02801,-0.73174 0.43546,0 0.9605,0.0978 0.9605,0.6215 v 1.13825 c 0,0.19982 0.0207,0.39826 0.0758,0.48783 h -0.6091 c -0.022,-0.0689 -0.0386,-0.14056 -0.0427,-0.21222 -0.19017,0.19844 -0.46991,0.27148 -0.73587,0.27148 -0.41479,0 -0.74552,-0.20809 -0.74552,-0.65595 0,-0.49609 0.37207,-0.61461 0.74552,-0.66559 0.36794,-0.0537 0.71107,-0.0413 0.71107,-0.28663 0,-0.25907 -0.17777,-0.29628 -0.38999,-0.29628 -0.22875,0 -0.3762,0.0923 -0.39687,0.32935 h -0.60082"
        id="path3240"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -291.11357,-370.29196 h 0.4396 v 0.40238 h -0.4396 v 1.08314 c 0,0.20257 0.051,0.25356 0.25356,0.25356 0.0634,0 0.12265,-0.004 0.18604,-0.0165 v 0.46991 c -0.1006,0.0165 -0.23289,0.0207 -0.3514,0.0207 -0.36793,0 -0.68902,-0.0854 -0.68902,-0.5209 v -1.28984 h -0.3638 v -0.40239 h 0.3638 v -0.65594 h 0.60082 v 0.65594"
        id="path3242"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -289.02308,-369.17437 c -0.1006,0.0882 -0.31281,0.0923 -0.49885,0.12678 -0.18603,0.0372 -0.35553,0.10059 -0.35553,0.32108 0,0.22462 0.17363,0.27974 0.36793,0.27974 0.46991,0 0.48645,-0.37207 0.48645,-0.50436 z m -1.38769,-0.44511 c 0.0345,-0.56224 0.53744,-0.73174 1.02802,-0.73174 0.43684,0 0.96049,0.0978 0.96049,0.6215 v 1.13825 c 0,0.19982 0.022,0.39826 0.0772,0.48783 h -0.61047 c -0.0207,-0.0689 -0.0372,-0.14056 -0.0413,-0.21222 -0.19017,0.19844 -0.46991,0.27148 -0.73587,0.27148 -0.41479,0 -0.74552,-0.20809 -0.74552,-0.65595 0,-0.49609 0.37207,-0.61461 0.74552,-0.66559 0.36794,-0.0537 0.70969,-0.0413 0.70969,-0.28663 0,-0.25907 -0.17777,-0.29628 -0.38861,-0.29628 -0.22875,0 -0.3762,0.0923 -0.39825,0.32935 h -0.60083"
        id="path3244"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -287.93857,-371.12568 h 0.60083 v 3.02204 h -0.60083 v -3.02204"
        id="path3246"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -284.81179,-368.10364 h -0.57051 v -0.30592 h -0.0124 c -0.15296,0.24529 -0.41479,0.36518 -0.66835,0.36518 -0.63941,0 -0.80064,-0.36105 -0.80064,-0.90262 v -1.34496 h 0.60082 v 1.2361 c 0,0.35829 0.10612,0.53605 0.38586,0.53605 0.32521,0 0.46577,-0.18052 0.46577,-0.62563 v -1.14652 h 0.59945 v 2.18832"
        id="path3248"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -284.35291,-370.29196 h 0.57051 v 0.30454 h 0.0138 c 0.15158,-0.24529 0.41479,-0.3638 0.66835,-0.3638 0.63803,0 0.79926,0.35967 0.79926,0.90124 v 1.34634 h -0.60082 v -1.2361 c 0,-0.35967 -0.10611,-0.53744 -0.38448,-0.53744 -0.32659,0 -0.46577,0.18191 -0.46577,0.62701 v 1.14653 h -0.60083 v -2.18832"
        id="path3250"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -280.76312,-367.82941 c -0.13229,0.3514 -0.339,0.49471 -0.75379,0.49471 -0.12264,0 -0.24529,-0.008 -0.36793,-0.0207 v -0.49471 c 0.11437,0.008 0.23289,0.0248 0.3514,0.0207 0.2067,-0.0207 0.27423,-0.23702 0.2067,-0.41065 l -0.77032,-2.0519 h 0.64354 l 0.49472,1.49793 h 0.008 l 0.47956,-1.49793 h 0.6215 l -0.91364,2.46255"
        id="path3252"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -278.28265,-369.17437 c -0.10197,0.0882 -0.31419,0.0923 -0.50023,0.12678 -0.18603,0.0372 -0.35553,0.10059 -0.35553,0.32108 0,0.22462 0.17363,0.27974 0.36931,0.27974 0.46854,0 0.48645,-0.37207 0.48645,-0.50436 z m -1.38769,-0.44511 c 0.0331,-0.56224 0.53744,-0.73174 1.02802,-0.73174 0.43546,0 0.96049,0.0978 0.96049,0.6215 v 1.13825 c 0,0.19982 0.0207,0.39826 0.0758,0.48783 h -0.6091 c -0.0207,-0.0689 -0.0386,-0.14056 -0.0427,-0.21222 -0.19016,0.19844 -0.46991,0.27148 -0.73587,0.27148 -0.41479,0 -0.74552,-0.20809 -0.74552,-0.65595 0,-0.49609 0.37345,-0.61461 0.74552,-0.66559 0.36794,-0.0537 0.71107,-0.0413 0.71107,-0.28663 0,-0.25907 -0.17777,-0.29628 -0.38999,-0.29628 -0.22875,0 -0.3762,0.0923 -0.39687,0.32935 h -0.60083"
        id="path3254"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -326.98941,-366.89234 h 0.28663 v 1.6247 l 1.757,-1.6247 h 0.38861 l -1.3491,1.2485 1.41249,1.77354 h -0.37207 l -1.25677,-1.5751 -0.58016,0.53743 v 1.03767 h -0.28663 v -3.02204"
        id="path3256"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -322.94349,-365.06506 h -0.008 c -0.0345,0.0648 -0.15296,0.0854 -0.22461,0.0978 -0.452,0.0799 -1.01562,0.0758 -1.01562,0.50298 0,0.26734 0.23702,0.43271 0.48645,0.43271 0.40652,0 0.76619,-0.25908 0.76205,-0.68627 z m -1.42214,-0.32109 c 0.0262,-0.51125 0.38586,-0.73174 0.8847,-0.73174 0.38585,0 0.8034,0.11851 0.8034,0.7028 v 1.15893 c 0,0.10198 0.051,0.16123 0.1571,0.16123 0.0303,0 0.0634,-0.008 0.0854,-0.0179 v 0.22462 c -0.0593,0.0124 -0.10198,0.0179 -0.17364,0.0179 -0.27147,0 -0.31419,-0.15297 -0.31419,-0.38172 h -0.008 c -0.18604,0.28387 -0.37621,0.44373 -0.79513,0.44373 -0.40239,0 -0.73174,-0.19844 -0.73174,-0.63804 0,-0.61322 0.59669,-0.63527 1.17133,-0.70279 0.22049,-0.0248 0.34313,-0.0551 0.34313,-0.29628 0,-0.35967 -0.25769,-0.44787 -0.57188,-0.44787 -0.32935,0 -0.57464,0.15159 -0.58291,0.50712 h -0.26734"
        id="path3258"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -321.76113,-366.0545 h 0.44373 v 0.22462 h -0.44373 v 1.47175 c 0,0.17363 0.0248,0.2756 0.21497,0.28801 0.0758,0 0.15296,-0.004 0.22876,-0.0124 v 0.22876 c -0.0813,0 -0.1571,0.008 -0.23703,0.008 -0.35553,0 -0.47818,-0.11851 -0.47404,-0.49058 v -1.49379 h -0.38034 v -0.22462 h 0.38034 v -0.65595 h 0.26734 v 0.65595"
        id="path3260"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -319.57832,-365.06506 h -0.008 c -0.033,0.0648 -0.15158,0.0854 -0.22462,0.0978 -0.45199,0.0799 -1.01561,0.0758 -1.01561,0.50298 0,0.26734 0.23702,0.43271 0.48782,0.43271 0.40515,0 0.76481,-0.25908 0.76068,-0.68627 z m -1.42214,-0.32109 c 0.0262,-0.51125 0.38585,-0.73174 0.88471,-0.73174 0.38585,0 0.80477,0.11851 0.80477,0.7028 v 1.15893 c 0,0.10198 0.051,0.16123 0.15572,0.16123 0.0303,0 0.0634,-0.008 0.0854,-0.0179 v 0.22462 c -0.0593,0.0124 -0.10198,0.0179 -0.17364,0.0179 -0.27147,0 -0.31281,-0.15297 -0.31281,-0.38172 h -0.01 c -0.18604,0.28387 -0.37621,0.44373 -0.79513,0.44373 -0.40101,0 -0.73174,-0.19844 -0.73174,-0.63804 0,-0.61322 0.59669,-0.63527 1.17271,-0.70279 0.21911,-0.0248 0.34175,-0.0551 0.34175,-0.29628 0,-0.35967 -0.25769,-0.44787 -0.5705,-0.44787 -0.33073,0 -0.57603,0.15159 -0.58429,0.50712 h -0.26734"
        id="path3262"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -318.81489,-366.89234 h 0.26596 v 3.02204 h -0.26596 v -3.02204"
        id="path3264"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -317.92192,-364.96309 c 0,0.46578 0.25356,0.93156 0.76619,0.93156 0.51125,0 0.76481,-0.46578 0.76481,-0.93156 0,-0.4644 -0.25356,-0.93018 -0.76481,-0.93018 -0.51263,0 -0.76619,0.46578 -0.76619,0.93018 z m 1.79834,0 c 0,0.62701 -0.3638,1.1548 -1.03215,1.1548 -0.66973,0 -1.03353,-0.52779 -1.03353,-1.1548 0,-0.62563 0.3638,-1.1548 1.03353,-1.1548 0.66835,0 1.03215,0.52917 1.03215,1.1548"
        id="path3266"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -315.77218,-366.0545 h 0.26734 v 0.37621 h 0.008 c 0.0965,-0.26183 0.3886,-0.4396 0.69866,-0.4396 0.61323,0 0.79926,0.32247 0.79926,0.84198 v 1.40561 h -0.26734 v -1.36288 c 0,-0.37759 -0.12264,-0.66009 -0.55397,-0.66009 -0.42306,0 -0.67661,0.32109 -0.68488,0.74828 v 1.27469 h -0.26734 v -2.1842"
        id="path3268"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -313.53287,-366.0545 h 0.26734 v 2.1842 h -0.26734 z m 0,-0.83784 h 0.26734 v 0.42719 h -0.26734 v -0.42719"
        id="path3270"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -311.22603,-365.11468 c -0.0124,-0.40238 -0.26183,-0.77859 -0.69315,-0.77859 -0.43684,0 -0.678,0.38034 -0.71934,0.77859 z m -1.41249,0.22325 c 0.004,0.38998 0.20671,0.8599 0.71934,0.8599 0.3886,0 0.60082,-0.22876 0.68488,-0.55811 h 0.26734 c -0.11438,0.49471 -0.40239,0.78135 -0.95222,0.78135 -0.69454,0 -0.98668,-0.53193 -0.98668,-1.1548 0,-0.57464 0.29214,-1.1548 0.98668,-1.1548 0.70142,0 0.98116,0.61323 0.95911,1.22646 h -1.67845"
        id="path3272"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -310.6445,-366.0545 h 0.26596 v 0.37621 h 0.008 c 0.0978,-0.26183 0.38998,-0.4396 0.69866,-0.4396 0.61323,0 0.79926,0.32247 0.79926,0.84198 v 1.40561 h -0.26596 v -1.36288 c 0,-0.37759 -0.12264,-0.66009 -0.55397,-0.66009 -0.42443,0 -0.67799,0.32109 -0.68626,0.74828 v 1.27469 h -0.26596 v -2.1842"
        id="path3274"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -307.10294,-365.41509 c -0.0124,-0.33073 -0.26596,-0.47818 -0.57051,-0.47818 -0.23702,0 -0.51676,0.0923 -0.51676,0.37621 0,0.23702 0.27147,0.32108 0.45337,0.36794 l 0.35553,0.0813 c 0.30455,0.0455 0.6215,0.22324 0.6215,0.60358 0,0.47404 -0.46991,0.65595 -0.87505,0.65595 -0.5085,0 -0.85577,-0.23565 -0.89711,-0.76895 h 0.26596 c 0.0207,0.35967 0.28802,0.54571 0.64217,0.54571 0.2508,0 0.59807,-0.11025 0.59807,-0.4148 0,-0.25356 -0.23702,-0.33899 -0.47818,-0.39825 l -0.34313,-0.0758 c -0.34727,-0.0937 -0.60909,-0.21222 -0.60909,-0.58429 0,-0.44373 0.43545,-0.61323 0.82131,-0.61323 0.43546,0 0.78272,0.22876 0.79926,0.7028 h -0.26734"
        id="path3276"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -304.94218,-365.4578 h 1.07349 c 0.35141,0 0.65182,-0.22049 0.65182,-0.58843 0,-0.36793 -0.22049,-0.60082 -0.65182,-0.60082 h -1.07349 z m -0.28801,-1.43454 h 1.38355 c 0.49885,0 0.91778,0.24115 0.91778,0.78686 0,0.38171 -0.19844,0.69453 -0.58842,0.77032 v 0.008 c 0.39411,0.051 0.50849,0.32109 0.52916,0.68213 0.0124,0.20671 0.0124,0.6215 0.13918,0.77446 h -0.31695 c -0.0717,-0.11989 -0.0717,-0.34313 -0.0799,-0.46991 -0.0262,-0.42306 -0.0593,-0.89297 -0.60496,-0.8723 h -1.09141 v 1.34221 h -0.28801 v -3.02204"
        id="path3278"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -300.93071,-365.11468 c -0.0124,-0.40238 -0.26183,-0.77859 -0.69315,-0.77859 -0.43684,0 -0.678,0.38034 -0.71934,0.77859 z m -1.41249,0.22325 c 0.004,0.38998 0.20671,0.8599 0.71934,0.8599 0.38861,0 0.59944,-0.22876 0.68488,-0.55811 h 0.26597 c -0.113,0.49471 -0.40101,0.78135 -0.95085,0.78135 -0.69453,0 -0.98668,-0.53193 -0.98668,-1.1548 0,-0.57464 0.29215,-1.1548 0.98668,-1.1548 0.70142,0 0.98116,0.61323 0.96049,1.22646 h -1.67983"
        id="path3280"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -298.76719,-364.98789 c 0,-0.4272 -0.19844,-0.90538 -0.7028,-0.90538 -0.50712,0 -0.71933,0.452 -0.71933,0.90538 0,0.43959 0.22875,0.86678 0.71933,0.86678 0.46165,0 0.7028,-0.42306 0.7028,-0.86678 z m 0.26596,0.93844 c -0.004,0.65181 -0.25356,1.05007 -0.96876,1.05007 -0.43546,0 -0.86678,-0.19431 -0.90537,-0.66009 h 0.26734 c 0.0593,0.32109 0.34175,0.43546 0.63803,0.43546 0.49058,0 0.7028,-0.29214 0.7028,-0.82544 v -0.29628 h -0.008 c -0.12265,0.26734 -0.38172,0.44924 -0.69453,0.44924 -0.69729,0 -0.9853,-0.49885 -0.9853,-1.12034 0,-0.6022 0.35553,-1.10106 0.9853,-1.10106 0.31832,0 0.58842,0.19844 0.69453,0.4396 h 0.008 v -0.37621 h 0.26596 v 2.00505"
        id="path3282"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -296.46448,-365.11468 c -0.0124,-0.40238 -0.26183,-0.77859 -0.69316,-0.77859 -0.43684,0 -0.67799,0.38034 -0.71934,0.77859 z m -1.4125,0.22325 c 0.004,0.38998 0.20671,0.8599 0.71934,0.8599 0.38861,0 0.60083,-0.22876 0.68489,-0.55811 h 0.26596 c -0.113,0.49471 -0.40101,0.78135 -0.95085,0.78135 -0.69453,0 -0.98667,-0.53193 -0.98667,-1.1548 0,-0.57464 0.29214,-1.1548 0.98667,-1.1548 0.70142,0 0.98116,0.61323 0.96049,1.22646 h -1.67983"
        id="path3284"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -295.87882,-366.0545 h 0.24529 v 0.51264 h 0.008 c 0.13505,-0.35141 0.43133,-0.55949 0.82545,-0.54157 v 0.26596 c -0.48231,-0.0248 -0.81304,0.33073 -0.81304,0.78272 v 1.16445 h -0.26596 v -2.1842"
        id="path3286"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -294.58346,-366.0545 h 0.26596 v 2.1842 h -0.26596 z m 0,-0.83784 h 0.26596 v 0.42719 h -0.26596 v -0.42719"
        id="path3288"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -293.85172,-366.0545 h 0.26595 v 0.37621 h 0.01 c 0.0965,-0.26183 0.3886,-0.4396 0.69728,-0.4396 0.61323,0 0.80064,0.32247 0.80064,0.84198 v 1.40561 h -0.26734 v -1.36288 c 0,-0.37759 -0.12264,-0.66009 -0.55397,-0.66009 -0.42306,0 -0.67661,0.32109 -0.68626,0.74828 v 1.27469 h -0.26596 v -2.1842"
        id="path3290"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#18181b"
        fillOpacity={1}
        d="m -290.03869,-364.98789 c 0,-0.4272 -0.19844,-0.90538 -0.70143,-0.90538 -0.50849,0 -0.71933,0.452 -0.71933,0.90538 0,0.43959 0.22875,0.86678 0.71933,0.86678 0.46027,0 0.70143,-0.42306 0.70143,-0.86678 z m 0.26733,0.93844 c -0.004,0.65181 -0.25355,1.05007 -0.96876,1.05007 -0.43683,0 -0.86816,-0.19431 -0.90537,-0.66009 h 0.26597 c 0.0593,0.32109 0.34312,0.43546 0.6394,0.43546 0.49058,0 0.70143,-0.29214 0.70143,-0.82544 v -0.29628 h -0.008 c -0.12264,0.26734 -0.38034,0.44924 -0.69315,0.44924 -0.69867,0 -0.98668,-0.49885 -0.98668,-1.12034 0,-0.6022 0.35554,-1.10106 0.98668,-1.10106 0.31695,0 0.58704,0.19844 0.69315,0.4396 h 0.008 v -0.37621 h 0.26733 v 2.00505"
        id="path3292"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -333.0073,-371.9084 c -1.90583,0 -3.45061,1.80247 -3.45061,4.02525 0,2.22139 1.54478,4.02249 3.45061,4.02249 1.90582,0 3.45061,-1.8011 3.45061,-4.02249 0,-2.22278 -1.54479,-4.02525 -3.45061,-4.02525"
        id="path3294"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.41336,-365.95803 c -0.30868,-0.55122 -0.4892,-1.21268 -0.4892,-1.92512 0,-0.71383 0.18052,-1.37528 0.4892,-1.9265 v 3.85162"
        id="path3296"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -334.67886,-370.70951 c 0.19292,-0.16261 0.40238,-0.29765 0.62563,-0.40101 v 6.45335 c -0.22325,-0.10335 -0.43271,-0.2384 -0.62563,-0.40238 v -5.64996"
        id="path3298"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -333.32012,-371.32411 c 0.10336,-0.0124 0.20809,-0.0193 0.31282,-0.0193 0.10611,0 0.21084,0.007 0.31419,0.0193 v 6.87916 c -0.10335,0.0138 -0.20808,0.0207 -0.31419,0.0207 -0.10473,0 -0.20946,-0.007 -0.31282,-0.0193 v -6.88055"
        id="path3300"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -331.95862,-371.11052 c 0.22325,0.10336 0.43271,0.23978 0.62563,0.40377 v 5.64582 c -0.19292,0.16261 -0.40238,0.29903 -0.62563,0.40239 v -6.45198"
        id="path3302"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.59849,-369.80552 c 0.3073,0.54984 0.48645,1.20992 0.48645,1.92237 0,0.70969 -0.17915,1.37115 -0.48645,1.92098 v -3.84335"
        id="path3304"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -331.33299,-371.05402 v 0.19293 c -0.1943,-0.15434 -0.40376,-0.2825 -0.62563,-0.38034 v -0.16812 c 0.22049,0.0923 0.42995,0.21222 0.62563,0.35553"
        id="path3306"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -333.0073,-371.61902 c 0.10611,0 0.21084,0.006 0.31419,0.0179 v 0.15572 c -0.10335,-0.0124 -0.20808,-0.0193 -0.31419,-0.0193 -0.10473,0 -0.20946,0.007 -0.31282,0.0193 v -0.15572 c 0.10336,-0.0124 0.20809,-0.0179 0.31282,-0.0179"
        id="path3308"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -334.05323,-371.40955 v 0.16674 c -0.22187,0.0978 -0.43271,0.226 -0.62563,0.38034 v -0.19293 c 0.1943,-0.14331 0.40514,-0.2632 0.62563,-0.35415"
        id="path3310"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.17266,-367.88315 c 0,-0.92742 0.28664,-1.77492 0.7593,-2.42811 v 0.27148 c -0.38034,0.59944 -0.60633,1.34634 -0.60633,2.15663 0,0.80891 0.22599,1.55443 0.60633,2.15387 v 0.27285 c -0.47266,-0.65319 -0.7593,-1.50068 -0.7593,-2.42672"
        id="path3312"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -334.67886,-364.71229 v -0.19292 c 0.19292,0.15434 0.40376,0.28112 0.62563,0.38034 v 0.16674 c -0.22049,-0.0909 -0.43133,-0.21084 -0.62563,-0.35416"
        id="path3314"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -333.0073,-364.14867 c -0.10473,0 -0.20946,-0.007 -0.31282,-0.0179 v -0.15572 c 0.10336,0.0124 0.20809,0.0193 0.31282,0.0193 0.10611,0 0.21084,-0.007 0.31419,-0.0193 v 0.15572 c -0.10335,0.011 -0.20808,0.0179 -0.31419,0.0179"
        id="path3316"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -331.95862,-364.35951 v -0.16674 c 0.22187,-0.0978 0.43133,-0.226 0.62563,-0.38034 v 0.19292 c -0.19568,0.14332 -0.40514,0.26321 -0.62563,0.35416"
        id="path3318"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.59849,-365.73204 c 0.37896,-0.59944 0.60496,-1.34496 0.60496,-2.15111 0,-0.80891 -0.226,-1.55305 -0.60496,-2.1525 v -0.27285 c 0.47129,0.65319 0.75654,1.49931 0.75654,2.42535 0,0.92466 -0.28525,1.77078 -0.75654,2.42259 v -0.27148"
        id="path3320"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -329.64627,-364.27269 c 0.0234,-0.0992 0.10611,-0.19569 0.16123,-0.27699 -0.0703,-0.0358 -0.16123,-0.0827 -0.22324,-0.13642 0.13643,-0.20395 0.18466,-0.30731 0.20671,-0.55398 l -0.0179,-1.27468 h -0.0179 c -0.11163,0.38309 -0.26046,0.80753 -0.47405,1.11897 -0.0593,0.0896 -0.0717,0.11162 -0.10611,0.16536 -0.0413,0.0634 -0.13229,0.19568 -0.12816,0.42168 -0.0772,0.0165 -0.1695,-0.004 -0.25907,-0.011 0.0124,0.0965 0.0234,0.11576 -0.001,0.27423 -0.36931,0.0138 -0.43959,0.23841 -0.83647,0.44511 -0.18328,0.0937 -0.26045,0.13229 -0.50023,0.22186 v 0.022 c 0.7469,-0.0248 1.07625,0.0978 1.49242,-0.1819 0.0496,0.0648 0.0744,0.15296 0.10611,0.22875 0.0592,-0.0455 0.18603,-0.12953 0.2825,-0.15434 0.10886,0.10887 0.27147,0.16812 0.46164,0.15159 0.0262,-0.15159 -0.0275,-0.35691 -0.14607,-0.46027"
        id="path3322"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.5815,-364.52487 c -0.0496,0.0207 -0.30317,0.10473 -0.30317,0.10473 l -0.004,0.004 c -0.001,-0.0207 -0.005,-0.04 -0.0138,-0.0593 l -0.001,-0.004 c 0.0896,-0.0537 0.13367,-0.12402 0.13505,-0.13505 0,-0.001 0.008,-0.011 0.01,-0.011 0,0 0,0.001 0,0.001 0.008,0.011 0.10886,0.0854 0.17777,0.0992"
        id="path3324"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.75927,-365.68243 c 0.19706,-0.50849 0.16261,-0.52503 0.21773,-0.73725 -0.0565,0.71245 -0.26871,1.29811 -0.47542,1.83555 0,0 -0.0469,-0.0138 -0.0717,-0.01 -0.0413,-0.0482 -0.051,-0.11851 -0.051,-0.11851 -0.1061,-0.34727 0.226,-0.57051 0.38034,-0.97014"
        id="path3326"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.42761,-364.7426 0.22599,0.18879 v 10e-4 c -0.005,0.005 -0.0124,0.011 -0.0179,0.0165 -0.011,0.011 -0.0207,0.0234 -0.0276,0.0358 l -10e-4,0.003 c -0.11024,-0.0537 -0.1819,-0.0524 -0.1819,-0.0524 0.0276,-0.11989 0.003,-0.19292 0.003,-0.19292"
        id="path3328"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -331.73262,-363.8896 0.29077,-0.0896 c 0.45751,-0.16537 0.6215,-0.50712 0.966,-0.48783 0.0744,0.008 0.13505,0.0234 0.19569,0.0579 -10e-4,0.0207 0.006,0.0482 0.0124,0.0703 h -0.006 c -0.28663,0.17363 -0.91777,0.37207 -1.45934,0.44924"
        id="path3330"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.21402,-363.90476 c -0.0138,-0.0358 -0.0207,-0.11989 -0.073,-0.17777 0.0689,-0.0579 0.0841,-0.0896 0.10748,-0.14744 l 10e-4,10e-4 c 0.022,0.0124 0.0455,0.0193 0.0703,0.0221 h 0.003 l -0.10886,0.30179"
        id="path3332"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.16166,-364.31817 c -0.0441,-0.0441 -0.0441,-0.11575 0,-0.15985 0.0441,-0.0441 0.11576,-0.0441 0.15986,0 0.0441,0.0441 0.0441,0.11576 0,0.15985 -0.0441,0.0441 -0.11576,0.0441 -0.15986,0"
        id="path3334"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.94254,-364.06185 c -0.051,-0.0593 -0.0482,-0.0786 -0.0675,-0.15848 0.0262,-0.008 0.0634,-0.0345 0.0813,-0.0593 l 0.35416,0.38034 c -0.13229,0.0124 -0.28663,-0.0634 -0.36793,-0.16261"
        id="path3336"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -329.64627,-371.47983 c 0.0234,0.0992 0.10611,0.19568 0.16123,0.27836 -0.0703,0.0344 -0.16123,0.0827 -0.22324,0.13505 0.13643,0.20533 0.18466,0.3073 0.20671,0.55397 l -0.0179,1.27606 h -0.0179 c -0.11163,-0.38447 -0.26046,-0.80753 -0.47405,-1.12034 -0.0593,-0.0882 -0.0717,-0.11162 -0.10611,-0.16399 -0.0413,-0.0648 -0.13229,-0.19706 -0.12816,-0.42305 -0.0772,-0.0152 -0.1695,0.004 -0.25907,0.011 0.0124,-0.0965 0.0234,-0.11575 -0.001,-0.27285 -0.36931,-0.0138 -0.43959,-0.23978 -0.83647,-0.44649 -0.18328,-0.0937 -0.26045,-0.13229 -0.50023,-0.22186 v -0.0207 c 0.7469,0.0234 1.07625,-0.0978 1.49242,0.1819 0.0496,-0.0648 0.0744,-0.15434 0.10611,-0.23013 0.0592,0.0469 0.18603,0.12953 0.2825,0.15572 0.10886,-0.10887 0.27147,-0.1695 0.46164,-0.15296 0.0262,0.15296 -0.0275,0.35691 -0.14607,0.46026"
        id="path3338"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.5815,-371.22765 c -0.0496,-0.0193 -0.30317,-0.10473 -0.30317,-0.10473 l -0.004,-0.003 c -0.001,0.0193 -0.005,0.0386 -0.0138,0.0593 l -0.001,0.004 c 0.0896,0.0524 0.13367,0.12264 0.13505,0.13504 0,0 0.008,0.01 0.01,0.01 0,0 0,0 0,-10e-4 0.008,-0.01 0.10886,-0.0854 0.17777,-0.0992"
        id="path3340"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.75927,-370.06872 c 0.19706,0.50711 0.16261,0.52503 0.21773,0.73587 -0.0565,-0.71107 -0.26871,-1.29811 -0.47542,-1.83554 0,0 -0.0469,0.0138 -0.0717,0.01 -0.0413,0.0496 -0.051,0.11988 -0.051,0.11988 -0.1061,0.34589 0.226,0.56914 0.38034,0.97014"
        id="path3342"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.42761,-371.00992 0.22599,-0.18879 v -10e-4 c -0.005,-0.004 -0.0124,-0.011 -0.0179,-0.0165 -0.011,-0.011 -0.0207,-0.0234 -0.0276,-0.0358 l -10e-4,-0.003 c -0.11024,0.0537 -0.1819,0.0537 -0.1819,0.0537 0.0276,0.1185 0.003,0.19154 0.003,0.19154"
        id="path3344"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -331.73262,-371.86293 0.29077,0.091 c 0.45751,0.16399 0.6215,0.50574 0.966,0.48645 0.0744,-0.007 0.13505,-0.022 0.19569,-0.0565 -10e-4,-0.022 0.006,-0.0496 0.0124,-0.0703 h -0.006 c -0.28663,-0.17501 -0.91777,-0.37345 -1.45934,-0.45062"
        id="path3346"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.21402,-371.84639 c -0.0138,0.0345 -0.0207,0.11851 -0.073,0.17639 0.0689,0.0579 0.0841,0.091 0.10748,0.14883 l 10e-4,-0.001 c 0.022,-0.0138 0.0455,-0.0207 0.0703,-0.0234 l 0.003,10e-4 -0.10886,-0.30179"
        id="path3348"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -330.16166,-371.43298 c -0.0441,0.0441 -0.0441,0.11576 0,0.15985 0.0441,0.0427 0.11576,0.0427 0.15986,-0.001 0.0441,-0.0441 0.0441,-0.11576 0,-0.15985 -0.0441,-0.0441 -0.11576,-0.0441 -0.15986,0.001"
        id="path3350"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -329.94254,-371.6893 c -0.051,0.0579 -0.0482,0.0772 -0.0675,0.15848 0.0262,0.007 0.0634,0.0331 0.0813,0.0579 l 0.35416,-0.38034 c -0.13229,-0.0124 -0.28663,0.0648 -0.36793,0.16398"
        id="path3352"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -336.36834,-364.2782 c -0.0234,-0.1006 -0.10611,-0.19707 -0.16123,-0.27975 0.0717,-0.0345 0.16123,-0.0813 0.22325,-0.13504 -0.13643,-0.20533 -0.18466,-0.30731 -0.20671,-0.5526 l 0.0179,-1.27744 h 0.0193 c 0.11024,0.38447 0.25907,0.80753 0.47266,1.12035 0.0606,0.0896 0.0717,0.113 0.10611,0.16536 0.0413,0.0634 0.13229,0.19568 0.12954,0.42168 0.0758,0.0152 0.16812,-0.004 0.25769,-0.011 -0.011,0.0965 -0.0234,0.11576 0.001,0.27286 0.36932,0.0152 0.4396,0.23977 0.83785,0.44648 0.1819,0.0951 0.25907,0.13229 0.49885,0.22186 v 0.0207 c -0.7469,-0.0234 -1.07624,0.0992 -1.49241,-0.18053 -0.0482,0.0648 -0.0744,0.15297 -0.10611,0.22876 -0.0593,-0.0469 -0.18604,-0.12954 -0.28112,-0.15434 -0.11025,0.10886 -0.27286,0.16812 -0.46164,0.15158 -0.0276,-0.15158 0.0262,-0.35691 0.14469,-0.45888"
        id="path3354"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.43173,-364.53176 c 0.0482,0.0207 0.30317,0.10611 0.30317,0.10611 l 0.003,0.003 c 0.001,-0.0207 0.007,-0.04 0.0152,-0.0593 v -0.004 c -0.0882,-0.0537 -0.13367,-0.12402 -0.13504,-0.13504 0.001,-10e-4 -0.008,-0.011 -0.01,-0.011 0,0 0,10e-4 0,10e-4 -0.008,0.011 -0.10748,0.0854 -0.17638,0.0992"
        id="path3356"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.25534,-365.68932 c -0.19706,-0.50849 -0.16261,-0.52503 -0.21773,-0.73725 0.0565,0.71107 0.2701,1.29812 0.47543,1.83555 0,0 0.0469,-0.0138 0.0716,-0.01 0.0427,-0.0482 0.051,-0.1185 0.051,-0.1185 0.10749,-0.34727 -0.226,-0.57051 -0.38034,-0.97014"
        id="path3358"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.58561,-364.74949 -0.22738,0.18879 v 10e-4 c 0.006,0.005 0.0124,0.01 0.0193,0.0165 0.01,0.011 0.0193,0.0234 0.0276,0.0358 v 0.003 c 0.11024,-0.0537 0.1819,-0.0524 0.1819,-0.0524 -0.0275,-0.11851 -0.001,-0.19292 -0.001,-0.19292"
        id="path3360"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -334.28199,-363.89649 -0.28939,-0.0896 c -0.4575,-0.16537 -0.62287,-0.50712 -0.96738,-0.48645 -0.0744,0.007 -0.13505,0.022 -0.19568,0.0551 0.001,0.0234 -0.005,0.0496 -0.0124,0.0703 h 0.006 c 0.288,0.17501 0.91777,0.37345 1.45934,0.45062"
        id="path3362"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.79921,-363.91165 c 0.0124,-0.0358 0.0207,-0.11988 0.0717,-0.17639 -0.0689,-0.0593 -0.0841,-0.091 -0.10749,-0.14883 l -0.001,0.001 c -0.022,0.0124 -0.0455,0.0193 -0.0703,0.022 h -0.003 l 0.11024,0.30179"
        id="path3364"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.85295,-364.32506 c 0.0441,-0.0441 0.0441,-0.11575 0,-0.15985 -0.0441,-0.0441 -0.11576,-0.0441 -0.15985,0 -0.0441,0.0441 -0.0441,0.11575 0,0.15985 0.0441,0.0441 0.11575,0.0441 0.15985,0"
        id="path3366"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.07068,-364.06874 c 0.051,-0.0593 0.0469,-0.0786 0.0661,-0.15848 -0.0248,-0.008 -0.0634,-0.0345 -0.0813,-0.0593 l -0.35278,0.38033 c 0.13092,0.0124 0.28664,-0.0634 0.36794,-0.1626"
        id="path3368"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#c31d24"
        fillOpacity={1}
        d="m -336.36834,-371.48672 c -0.0234,0.0992 -0.10611,0.19568 -0.16123,0.27836 0.0717,0.0344 0.16123,0.0813 0.22325,0.13505 -0.13643,0.20533 -0.18466,0.3073 -0.20671,0.55397 l 0.0179,1.27606 h 0.0193 c 0.11024,-0.38447 0.25907,-0.80753 0.47266,-1.12034 0.0606,-0.0882 0.0717,-0.11162 0.10611,-0.16399 0.0413,-0.0648 0.13229,-0.19706 0.12954,-0.42306 0.0758,-0.0152 0.16812,0.004 0.25769,0.011 -0.011,-0.0965 -0.0234,-0.11575 0.001,-0.27285 0.36932,-0.0138 0.4396,-0.23978 0.83785,-0.44511 0.1819,-0.0951 0.25907,-0.13367 0.49885,-0.22324 v -0.0207 c -0.7469,0.0234 -1.07624,-0.0992 -1.49241,0.1819 -0.0482,-0.0648 -0.0744,-0.15434 -0.10611,-0.23013 -0.0593,0.0469 -0.18604,0.13091 -0.28112,0.15434 -0.11025,-0.10749 -0.27286,-0.16812 -0.46164,-0.15158 -0.0276,0.15296 0.0262,0.35691 0.14469,0.46026"
        id="path3370"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.43173,-371.23454 c 0.0482,-0.0207 0.30317,-0.10473 0.30317,-0.10473 l 0.003,-0.003 c 0.001,0.0193 0.007,0.04 0.0152,0.0579 v 0.005 c -0.0882,0.0524 -0.13367,0.12265 -0.13504,0.13505 0.001,10e-4 -0.008,0.01 -0.01,0.01 0,0 0,-10e-4 0,-10e-4 -0.008,-0.01 -0.10748,-0.0841 -0.17638,-0.0992"
        id="path3372"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.25534,-370.07699 c -0.19706,0.50987 -0.16261,0.52641 -0.21773,0.73725 0.0565,-0.71107 0.2701,-1.29811 0.47543,-1.83554 0,0 0.0469,0.0152 0.0716,0.01 0.0427,0.0496 0.051,0.11988 0.051,0.11988 0.10749,0.34727 -0.226,0.56913 -0.38034,0.96877"
        id="path3374"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.58561,-371.01681 -0.22738,-0.18879 v -10e-4 c 0.006,-0.006 0.0124,-0.01 0.0193,-0.0165 0.01,-0.011 0.0193,-0.022 0.0276,-0.0345 v -0.004 c 0.11024,0.0537 0.1819,0.0524 0.1819,0.0524 -0.0275,0.11989 -0.001,0.19293 -0.001,0.19293"
        id="path3376"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -334.28199,-371.86982 -0.28939,0.091 c -0.4575,0.16399 -0.62287,0.50574 -0.96738,0.48645 -0.0744,-0.008 -0.13505,-0.022 -0.19568,-0.0565 0.001,-0.0234 -0.005,-0.0496 -0.0124,-0.0703 h 0.006 c 0.288,-0.17501 0.91777,-0.37345 1.45934,-0.45062"
        id="path3378"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.79921,-371.85466 c 0.0124,0.0358 0.0207,0.11989 0.0717,0.17639 -0.0689,0.0593 -0.0841,0.0923 -0.10749,0.15021 l -0.001,-0.001 c -0.022,-0.0138 -0.0455,-0.0207 -0.0703,-0.0234 l -0.003,10e-4 0.11024,-0.30317"
        id="path3380"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -335.85295,-371.43987 c 0.0441,0.0441 0.0441,0.11576 0,0.15847 -0.0441,0.0441 -0.11576,0.0441 -0.15985,0 -0.0441,-0.0441 -0.0441,-0.11575 0,-0.15985 0.0441,-0.0441 0.11575,-0.0427 0.15985,0.001"
        id="path3382"
        style={{
          strokeWidth: 0.352778,
        }}
      />
      <path
        fillRule="nonzero"
        fill="#ffffff"
        fillOpacity={1}
        d="m -336.07068,-371.69756 c 0.051,0.0606 0.0469,0.0785 0.0661,0.15985 -0.0248,0.007 -0.0634,0.0331 -0.0813,0.0579 l -0.35278,-0.38034 c 0.13092,-0.0124 0.28664,0.0648 0.36794,0.16261"
        id="path3384"
        style={{
          strokeWidth: 0.352778,
        }}
      />
    </g>
  </svg>
);
export default SVGComponent;
